import Vivus from 'vivus';
import reasonPath from '../../images/media/reason-path.svg';
import charmPath from '../../images/common/charm-path.svg';

import person1 from '../../images/common/person-icon-1.svg';
import person2 from '../../images/common/person-icon-2.svg';
import person3 from '../../images/common/person-icon-3.svg';

import message from '../../images/common/message-path.svg';

const reason = document.getElementById('reason-path'),
  charm = document.getElementById('charm-path'),
  personElm1 = document.getElementById('person-1'),
  personElm2 = document.getElementById('person-2'),
  personElm3 = document.getElementById('person-3');

const persons = [person1, person2, person3];

const messageElm = document.getElementById('message-path');

if (reason) {
  new Vivus('reason-path', {
    duration: 300,
    file: reasonPath,
    type: 'delayed',
    forceRender: false,
    animTimingFunction: Vivus.EASE_OUT,
  })
}

if (charm) {
  new Vivus('charm-path', {
    duration: 300,
    file: charmPath,
    type: 'delayed',
    forceRender: false,
    animTimingFunction: Vivus.EASE_OUT,
  })
}

if (personElm1) {

  new Vivus(`person-1`, {
    duration: 200,
    file: person1,
    type: 'delayed',
    forceRender: false,
    animTimingFunction: Vivus.EASE_OUT,
  })

  new Vivus(`person-2`, {
    duration: 200,
    file: person2,
    type: 'delayed',
    forceRender: false,
    animTimingFunction: Vivus.EASE_OUT,
  })

  new Vivus(`person-3`, {
    duration: 200,
    file: person3,
    type: 'delayed',
    forceRender: false,
    animTimingFunction: Vivus.EASE_OUT,
  })

}

if (messageElm) {
  new Vivus('message-path', {
    duration: 300,
    file: message,
    forceRender: false,
    animTimingFunction: Vivus.EASE_OUT,
  })
}